import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  dark?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  dark = false
}: SectionProps) {
  return <section id={id} className={`py-16 md:py-24 px-4 md:px-6 w-full overflow-hidden ${dark ? 'bg-slate-900 text-white' : 'bg-white text-slate-900'} ${className}`} data-id="element-292">
      <div className="max-w-4xl mx-auto" data-id="element-293">{children}</div>
    </section>;
}
export const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};